import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/3ef61ee7b79bfd4f58139615bd54ebef/d3228d73601c63ee0c37507599593360.png" 
              alt="株式会社Free CS" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              EC事業者様の物流業務を支援し、<br />
              本業に集中できる環境づくりを<br />
              サポートいたします。
            </p>
            <div className="flex items-start gap-2 text-sm text-gray-400">
              <i className="ri-map-pin-line text-orange-400 mt-1"></i>
              <div>
                〒132-0025<br />
                東京都江戸川区松島1-17-4 1階
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-orange-400">会社情報</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/company" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  代表挨拶
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-orange-400">サービス</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  梱包・発送代行
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  卸売・小売業務
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  EC運営サポート
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-orange-400">お問い合わせ</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                  お問い合わせフォーム
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © 2025 株式会社Free CS. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
